<div class="container-fluid">
  <div class="row m-row">
    <div class="col-lg-6 slider-container p-3">
      <div class="right-panel">
        <div class="right-panel-head p-3">
          <div class="dropdown">
            <button
              class="btn btn-default dropdown-toggle lang-dropdown"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ currentLanguage === 'ar' ? 'العربية' : 'English' }}
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" (click)="changeLanguage('en-US')"
                >English</a
              >
              <a class="dropdown-item" (click)="changeLanguage('ar')"
                >العربية</a
              >
            </div>
          </div>
        </div>
        <app-splash-screen-sliders
          [isWhiteBackground]="false"
        ></app-splash-screen-sliders>
      </div>
    </div>
    <div class="col-lg-6 main-content">
      <div class="main-header">
        <div class="d-flex justify-content-between">
          @if (contactInfo) {
            <div class="contact-div mt-3 pt-2" [dir]="dir">
              <button mat-stroked-button [matMenuTriggerFor]="userMenu">
                <mat-icon
                  fontSet="material-icons-outlined"
                  class="text-secondary"
                  >help</mat-icon
                >
                <span translate class="text-secondary">Contact Us</span>
              </button>
              <mat-menu #userMenu="matMenu">
                <a
                  mat-menu-item
                  href="tel:{{ contactInfo.supportNumber | numberTranslate }}"
                  class="text-left"
                  dir="ltr"
                  translate
                >
                  <mat-icon>phone</mat-icon>
                  <span dir="ltr">{{
                    contactInfo.supportNumber | numberTranslate
                  }}</span>
                </a>
                <a
                  mat-menu-item
                  href="mailto:{{ contactInfo.supportEmail }}"
                  class="text-left"
                  dir="ltr"
                  translate
                >
                  <mat-icon>email</mat-icon>
                  {{ contactInfo.supportEmail }}
                </a>
              </mat-menu>
            </div>
          }
          <div class="language-div mt-3 pt-2">
            <app-language-selector [icon]="true"></app-language-selector>
          </div>
        </div>
      </div>

      <app-register-basic-info
        dir="{{ htmlTag.dir }}"
        [hidden]="step !== 1"
        (proceed)="proceed($event)"
      ></app-register-basic-info>
      <app-verify-otp
        #verifyOtp
        dir="{{ htmlTag.dir }}"
        [hidden]="step !== 2"
        [accountData]="accountData"
        (back)="back(1)"
      ></app-verify-otp>
    </div>
  </div>
</div>
